/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_COUNTRY = 'REQUEST_COUNTRY';
export const REQUEST_COUNTRY_SUCCESS = 'REQUEST_COUNTRY_SUCCESS';
export const REQUEST_COUNTRY_FAILURE = 'REQUEST_COUNTRY_FAILURE';

export const REQUEST_PROVINCE = 'REQUEST_PROVINCE';
export const REQUEST_PROVINCE_SUCCESS = 'REQUEST_PROVINCE_SUCCESS';
export const REQUEST_PROVINCE_FAILURE = 'REQUEST_PROVINCE_FAILURE';

export const REQUEST_CITY = 'REQUEST_CITY';
export const REQUEST_CITY_SUCCESS = 'REQUEST_CITY_SUCCESS';
export const REQUEST_CITY_FAILURE = 'REQUEST_CITY_FAILURE';

export const REQUEST_SUB_DISTRICT = 'REQUEST_SUB_DISTRICT';
export const REQUEST_SUB_DISTRICT_SUCCESS = 'REQUEST_SUB_DISTRICT_SUCCESS';
export const REQUEST_SUB_DISTRICT_FAILURE = 'REQUEST_SUB_DISTRICT_FAILURE';

export const REQUEST_DISTRICT = 'REQUEST_DISTRICT';
export const REQUEST_DISTRICT_SUCCESS = 'REQUEST_DISTRICT_SUCCESS';
export const REQUEST_DISTRICT_FAILURE = 'REQUEST_DISTRICT_FAILURE';

export const REQUEST_POSTAL_CODE = 'REQUEST_POSTAL_CODE';
export const REQUEST_POSTAL_CODE_SUCCESS = 'REQUEST_POSTAL_CODE_SUCCESS';
export const REQUEST_POSTAL_CODE_FAILURE = 'REQUEST_POSTAL_CODE_FAILURE';


